import { render, staticRenderFns } from "./setting-create-team-sidebar.vue?vue&type=template&id=628f2b0e&scoped=true&"
import script from "./setting-create-team-sidebar.vue?vue&type=script&lang=js&"
export * from "./setting-create-team-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./setting-create-team-sidebar.vue?vue&type=style&index=0&id=628f2b0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f2b0e",
  null
  
)

export default component.exports